/* eslint-disable no-unused-vars */
export enum RequestStatus {
  DEFAULT,
  SUCCESS,
  FAILURE,
  LOADING,
  CONFLICT,
}
